import { contractApi } from '@atheneum/api'
import { extendObservable, computed } from 'mobx'

class ContractsStore {
  constructor (staticData) {
    extendObservable(this, {
      loading: null,
      error: null,
      contractsCount: null,
      contracts: [],
      staticData,
      query: this.getEmptyQuery(staticData),
      contractTypes: computed(() => {
        return staticData.contractTypes
      })
    })
  }

  resetFilter () {
    this.query = this.getEmptyQuery(this.staticData)
    this.filter()
  }

  getEmptyQuery (staticData) {
    const { ACTIVE, EXPIRING_SOON } = staticData.CONST.CONTRACT_STATUSES

    return {
      page: 1,
      contractStatuses: [ACTIVE, EXPIRING_SOON],
      searchString: '',
      contractTypeId: 0,
      parentAccountId: 0,
      limit: 15
    }
  }

  filter (id) {
    this.loading = true
    return contractApi.search(this.query)
      .then(res => {
        this.contractsCount = res.count
        this.contracts.replace(res.rows)
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }

  changePage (page) {
    this.query.page = page
    this.filter()
  }
}

export default ContractsStore
